import { render } from "./ChangeBgpPeerForVpc.vue?vue&type=template&id=5f92b8c2&scoped=true"
import script from "./ChangeBgpPeerForVpc.vue?vue&type=script&lang=js"
export * from "./ChangeBgpPeerForVpc.vue?vue&type=script&lang=js"

import "./ChangeBgpPeerForVpc.vue?vue&type=style&index=0&id=5f92b8c2&scoped=true&lang=scss"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f92b8c2"]])

export default __exports__